import React, { Component } from 'react';
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Grid,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {
  AlignedGrid, QuoteComparisonExpansionPanel, createLoanGridElements, createLoanGridLabel,
  createLoanGridElementsWithRenderer,
  createMoneyLoanGridElements,
  createPeriodLoanGridElements,
  RightAlignedDiv,
  QuoteComparisonExpansionSummary,QuoteComparisonExpansionPanelDetails,
  createMultiLineStringLoanGridElements
} from './QuoteComparisonGridElements';
import numberFormatter from 'utils/numberFormatter';


class Prepayment extends Component {
  state = {
    expanded:true
  }

  renderRate = (property) => {
    return (loan) => {
      let value = loan[property];
      if(!value && value !== 0)
        return (<RightAlignedDiv>{'\u2014'}</RightAlignedDiv>)
      return (<RightAlignedDiv>{numberFormatter.formatRate(loan[property], 2, '\u2014')}</RightAlignedDiv>)
    }
  }

  handleChange = (event, expanded) => {
    this.setState({
      expanded: expanded
    });
  }
  render() {
    const { loans,isCombined } = this.props;
    const { expanded } = this.state;
    return (
      <QuoteComparisonExpansionPanel onChange={this.handleChange} defaultExpanded>
        <QuoteComparisonExpansionSummary expandIcon={<ExpandMoreIcon />} expanded={expanded}>
          <Grid container direction="row" alignItems="stretch">
            {createLoanGridLabel("Prepayment")}
            {expanded && (!isCombined ? createLoanGridElements(loans, 'prepaymentTermsPrepaymentType', '\u2014',isCombined) : createMultiLineStringLoanGridElements(loans, 'prepaymentTermsPrepaymentType', '\u2014',isCombined))}
          </Grid>
        </QuoteComparisonExpansionSummary>
        <QuoteComparisonExpansionPanelDetails>
          <AlignedGrid container direction="row" justify="flex-start" alignItems="stretch">
          </AlignedGrid>
        </QuoteComparisonExpansionPanelDetails>
        <QuoteComparisonExpansionPanelDetails>
          <AlignedGrid container direction="row" justify="flex-start" alignItems="stretch">
            <Grid item xs={12}></Grid>
            {createLoanGridLabel("Exit Fees")}
            {createLoanGridElementsWithRenderer(loans, this.renderRate('prepaymentTermsExitFee'),'\u2014', isCombined)}
          </AlignedGrid>
        </QuoteComparisonExpansionPanelDetails>
      </QuoteComparisonExpansionPanel>
    )
  }
}

export default Prepayment;